<template>
  <div class="regist">
    <section>
      <HeadingLv3 text="ご希望のエリアをお選びください。" setLabelSlot>
        <em>必須</em><span>※複数選択可</span>
      </HeadingLv3>
      <template v-for="(area, i) in areas" :key="i">
        <FormAreaCheckbox
          :id="`area${i}`"
          :label="area.name"
          :items="area.prefectures"
          @check-prefecture="checkPrefecture(i, $event)"
        />
      </template>
    </section>

    <GoalButtons>
      <Button label="戻る" :handleClick="goBack" />
      <Button
        label="こだわり選択へ"
        :handleClick="goForward"
        :disabled="isDisabledNextBtn"
        primary
      />
    </GoalButtons>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  computed,
  SetupContext,
  reactive
} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import GoalButtons from '@/components/block/GoalButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import FormAreaCheckbox from '@/components/block/FormAreaCheckbox.vue'

export default defineComponent({
  name: 'RegisterEventsArea',

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  components: {
    FormAreaCheckbox,
    GoalButtons,
    HeadingLv3,
    Button
  },

  setup(props: any, context: SetupContext) {
    const store = useStore()
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    interface Item {
      label: string
      value: string
      id: string
      area: string
      checked?: boolean
    }

    const areas: Array<any> = reactive([])
    const tempAreas: Array<string> = []
    const tempItems: Array<Item> = []

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      tempAreas.push(el.area)

      const item: Item = {
        label: el.option_name,
        value: el.opt_id,
        id: 'prefecture' + el.opt_id,
        area: el.area,
        checked:
          props.data.hopePrefectures.indexOf(el.opt_id) > -1 ? true : false
      }
      tempItems.push(item)
    })

    const areaNames = Array.from(new Set(tempAreas))

    areaNames.forEach((area) => {
      const prefectures = tempItems.filter((item) => {
        return area === item.area
      })

      areas.push({
        name: area,
        prefectures: prefectures
      })
    })

    const checkPrefecture = (index: number, prefecture: any) => {
      areas[index].prefectures.forEach((item: Item) => {
        if (prefecture.value === item.value) item.checked = prefecture.checked
      })

      context.emit('update-prefectures', prefecture)
    }

    const isDisabledNextBtn = computed(() => {
      return props.data.hopePrefectures.length === 0 ? true : false
    })

    const goBack = () => {
      router.push(
        `/register/events/user_category?event_id=${props.data.event_id}`
      )
    }

    const goForward = () => {
      router.push(`/register/events/terms?event_id=${props.data.event_id}`)
    }

    onMounted(() => {
      context.emit('update-flow', 2)
    })

    return {
      areas,
      checkPrefecture,
      isDisabledNextBtn,
      goBack,
      goForward
    }
  }
})
</script>
